import { BOOLEAN_BYTES_PER_ELEMENT, BusMessage, MessageFactory, UID_BYTES_PER_ELEMENT, UID_SAFE_BYTES_PER_ELEMENT } from "flavr-common";
/**
 * Requests generating a skybox.
 */
export class GenerateSkyboxMessage extends BusMessage {
    get byteLength() {
        let byteLength = BOOLEAN_BYTES_PER_ELEMENT + // isPosition
            UID_SAFE_BYTES_PER_ELEMENT; // targetRoomUid
        byteLength += Array.isArray(this.target) ? Float32Array.BYTES_PER_ELEMENT * 3 : UID_BYTES_PER_ELEMENT;
        return byteLength;
    }
    constructor(target, targetRoomUid) {
        super();
        this.target = target;
        this.targetRoomUid = targetRoomUid;
    }
    serialization(stream) {
        const isPosition = stream.boolean(Array.isArray(this.target));
        if (isPosition) {
            this.target = stream.number3(this.target);
        }
        else {
            this.target = stream.uid(this.target);
        }
        this.targetRoomUid = stream.uidSafe(this.targetRoomUid);
    }
    static is(msg) {
        return msg.type === GenerateSkyboxMessage.typestatic;
    }
}
GenerateSkyboxMessage.typestatic = "GenerateSkyboxMessage";
GenerateSkyboxMessage.subjectstatic = "general";
MessageFactory.register(GenerateSkyboxMessage);
/**
 * Returns the result of skybox generation.
 */
export class ResponseGenerateSkyboxMessage extends BusMessage {
    get byteLength() {
        return Uint32Array.BYTES_PER_ELEMENT;
    }
    constructor(id) {
        super();
        this.id = id;
    }
    serialization(stream) {
        this.id = stream.uint32(this.id);
    }
    static is(msg) {
        return msg.type === ResponseGenerateSkyboxMessage.typestatic;
    }
}
ResponseGenerateSkyboxMessage.typestatic = "ResponseGenerateSkyboxMessage";
ResponseGenerateSkyboxMessage.subjectstatic = "general";
MessageFactory.register(ResponseGenerateSkyboxMessage);
/**
 * Sets the generated skybox that should be used.
 */
export class SetGeneratedSkyboxMessage extends BusMessage {
    get byteLength() {
        return Uint32Array.BYTES_PER_ELEMENT;
    }
    constructor(id) {
        super();
        this.id = id;
    }
    serialization(stream) {
        this.id = stream.uint32(this.id);
    }
    static is(msg) {
        return msg.type === SetGeneratedSkyboxMessage.typestatic;
    }
}
SetGeneratedSkyboxMessage.typestatic = "SetSkyboxMessage";
SetGeneratedSkyboxMessage.subjectstatic = "general";
MessageFactory.register(SetGeneratedSkyboxMessage);
